import { KeyValue } from "../types";

export const separators: KeyValue = {
  AND: "AND",
  OR: "OR",
};

export const conditionType: KeyValue = {
  GROUP: 2,
  CONDITION: 1,
  QUERY: 3,
  SEPARATOR: 4,
};

export const selectors: KeyValue = {
  NUMERIC: "NUMERIC",
  DROPDOWN: "DROPDOWN",
  TEXT: "TEXT",
  OPTIONS: "OPTIONS",
  CHECKBOX: "CHECKBOX",
};

export const operators: KeyValue = {
  AND: "AND",
  OR: "OR",
  EQUAL: "EQUAL",
  NOT_EQUAL: "NOT_EQUAL",
  GREATER_THAN: "GREATER_THAN",
  LESS_THAN: "LESS_THAN",
  LESS_THAN_OR_EQUAL_TO: "LESS_THAN_OR_EQUAL_TO",
  GREATER_THAN_OR_EQUAL_TO: "GREATER_THAN_OR_EQUAL_TO",
  BETWEEN: "BETWEEN",
  LIKE: "LIKE",
  ANY: "ANY",
  NOT: "NOT",
};

export const actions: KeyValue = {
  hidden: "hidden",
  required: "required",
  readonly: "readonly",
  error: "error",
  persontype: "persontype",
  webconf:"webconf",
  emailconf:"emailconf",
  groupemailconf:"groupemailconf"
};

export const eventOperators: KeyValue = {
  EQUAL: "=",
  NOT_EQUAL: "!=",
};

const fieldOperators: KeyValue = {
  EQUAL: "=",
  NOT_EQUAL: "!=",
  GREATER_THAN: ">",
  LESS_THAN: "<",
  LESS_THAN_OR_EQUAL_TO: "<=",
  GREATER_THAN_OR_EQUAL_TO: ">=",
  LIKE: "LIKE",
};

const questionOptionOperators: KeyValue = {
  EQUAL: "=",
  NOT_EQUAL: "!=",
  ANY: "ANY",
};

const questionTextOperators: KeyValue = {
  EQUAL: "=",
  NOT_EQUAL: "!=",
  GREATER_THAN: ">",
  LESS_THAN: "<",
  LESS_THAN_OR_EQUAL_TO: "<=",
  GREATER_THAN_OR_EQUAL_TO: ">=",
  LIKE: "LIKE",
};

const conditionActionTypes: KeyValue = {
  CHECK_CONDITION_REQUEST: "CHECK_CONDITION_REQUEST",
  CHECK_CONDITION_SUCCESS: "CHECK_CONDITION_SUCCESS",
};

export const conditionConstants = {
  operators,
  actions,
  eventOperators,
  fieldOperators,
  questionOptionOperators,
  questionTextOperators,
  selectors,
  separators,
  actionTypes: conditionActionTypes,
};
